import { render } from "./Benefits.vue?vue&type=template&id=1d3ed0f9"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__